// DD - TODO - move to store after pre-test
let __nodesMap = {};
let __lastRootNode = null;

function __getNodeById (id) {
        return __nodesMap[id];
}

function __setNode (node) {
    if (node) __nodesMap[node.code] = node;
}

function __setLastRootNode (node) {
    if (node) __lastRootNode = node;
}

function __getLastRootNode () {
    return __lastRootNode;
}

function __getNodeTreeNames (code) {
    if (!code) return [];
    const node = __nodesMap[code];
    const ids = node.path.split('-');
    let names = [];

    ids.forEach(id => {
        const nId = parseInt(id, 10);
        const n = __nodesMap[nId];
        names.push(n.description + ' Code: ' + n.code);
    });

    return names;
}

export const officeNodeService = {
    getNodeById: (id) => __getNodeById(id),
    setNode: (node) => __setNode(node),
    setLastRootNode: (node) => __setLastRootNode(node),
    getLastRootNode: () => __getLastRootNode(),
    getNodeTreeNames: (id) => __getNodeTreeNames(id)
};
